import ApiMethods from 'shared/api/api-methods';

import type { EnvVariable, EnvVarWithId } from '@/enteties/env-variables/model';

const url = '/env';

export function getAllEnvVariables(slug: string) {
  return ApiMethods.get(`${url}/${slug}`);
}

export function deleteEnvVariable(slug: string, id: number) {
  return ApiMethods.delete(`${url}/${slug}/${id}`);
}

export function addEnvVariable(slug: string, data: EnvVariable) {
  return ApiMethods.post(`${url}/${slug}`, data);
}

export function editEnvVariable(slug: string, id: number, data: EnvVarWithId) {
  return ApiMethods.put(`${url}/${slug}/${id}`, data);
}
